import axios from 'axios'
const ServiceURL = process.env.VUE_APP_SERVICEURL
const SimfoniURL = process.env.VUE_APP_SIMFONI

export default {
  name: 'authentication',
  state: {
    auth: {
      fullname: String,
      username: String,
      password: String,
      nik: String,
      apikey: String,
      foto: String,
      role: String,
      hak_Akses: [],
      Signature: String,
      id_user: String,
      divisi: [],
      nama_bidang: [],
      posisi: [],
      job_desc: [],
      pimpro: []
    },
    isLogin: false
  },
  getters: {
    getAuth: state => {
      return state.auth
    },
    getIsLogin: state => {
      return state.isLogin
    }
  },
  mutations: {
    AUTH: (state, payload) => {
      state.auth.username = payload.message.tlc
      state.auth.password = payload.message.password
      state.auth.apikey = payload.message.key
      state.auth.foto = payload.message.foto
      state.auth.role = payload.message.role
      state.auth.hak_Akses = payload.message.hak_akses
      state.auth.Signature = payload.message.ttd_user
      state.auth.id_user = payload.message.id_user

      axios({
        method: 'get',
        url: SimfoniURL + 'user/allkaryawan',
        auth: {
          username: payload.message.tlc,
          password: payload.message.password
        },
        headers: {
          'X-API-KEY': payload.message.key
        }
      }).then(response => {
        response.data.data.forEach(item => {
          if (item.tlc === payload.message.tlc) {
            state.auth.fullname = item.nama,
            state.auth.nik = item.nik
          }
        })
      })
        .catch(err => {
          return err
        })
    },
    USER_ACCESS: (state, payload) => {
      state.auth.hak_Akses = payload.hak_akses
      state.auth.divisi = payload.divisi
      state.auth.nama_bidang = payload.nama_bidang
      state.auth.posisi = payload.posisi
      state.auth.job_desc = payload.job_desc
      state.auth.pimpro = payload.pimpro
    },
    ISLOGIN: (state, payload) => {
      state.isLogin = payload
    }
  },
  actions: {
    SET_AUTH(store, payload) {
      store.commit('AUTH', payload)
    },

    async FETCH_USER_ACCESS(store, payload) {
      return await axios({
        method: 'get',
        url: ServiceURL + 'user/user_access',
        params: {
          tlc: payload
        },
        auth: {
          username: store.rootState.auth.auth.username,
          password: store.rootState.auth.auth.password
        },
        headers: {
          'X-API-KEY': store.rootState.auth.auth.apikey
        }
      }).then(response => {
        store.commit('USER_ACCESS', response.data.data[0])
      }).catch(err => {
        return err
      })
    },
    SET_ISLOGIN(store, payload) {
      store.commit('ISLOGIN', payload)
    }
  }
}
